<template>
  <el-dialog
    class="radish-dia"
    title="选择表头名称"
    top="70px"
    width="200px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-if="dialogVisible">
      <el-select v-if="fields.length > 0" v-model="field" filterable size="mini" placeholder="选择表头名称">
        <el-option v-for="(v, k) in fields" :key="k" :label="v" :value="v"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import radishFields from './radish-fields.js'

export default {
  data: function() {
    return {
      dialogVisible: false,
      fields: [],
      field: '',
      onConfirm: function() {},
    }
  },
  methods: {
    show: function(param) {
      const { heads, type, onConfirm } = param
      this.field = ''
      this.fields = type === 'add' ? radishFields.filter(f => !heads.includes(f)) : heads
      this.onConfirm = onConfirm
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      if (!this.field) {
        this.$message.info('请选择表头名称')
        return
      }
      this.onConfirm(this.field)
      this.dialogVisible = false
    },
  },
}
</script>
